import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  memberId: number;
  memberName: string;
  compId: number;
  compName: string;
  masterYn: string;
}

interface AuthData {
  accessToken: string;
  refreshToken: string;
  user: User;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  setAuth: (auth: AuthData) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setAuth: (auth) => set({ accessToken: auth.accessToken, refreshToken: auth.refreshToken, user: auth.user }),
      logout: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    { name: 'auth' },
  ),
);
